<template>
  <v-container>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-container>
          <v-row class="my-n8">
            <v-col>
              <v-select
                :items="stations"
                label="Stasiun"
                v-model="selectStation"
                return-object
                :rules="nameRules"
                @change="change(selectStation)"
                class="float-right"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <!-- Firmware Version -->
              <v-row>
                <v-col class="my-n4">
                  <v-text-field
                    v-model="version"
                    :rules="numberOnly"
                    label="New Version Number"
                    required
                  ></v-text-field>
                  <v-btn color="primary" class="float-right" @click="saveVersion(selectStation)">
                    SAVE
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Kalibrasi M -->
            <v-row>
              <v-col class="my-n4">
                <v-text-field
                  v-model="calibM"
                  :rules="number"
                  label="Kalibrasi M"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Kalibrasi B -->
            <v-row>
              <v-col class="my-n4">
                <v-text-field
                  v-model="calibB"
                  :rules="number"
                  label="Kalibrasi B"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Periodic Report -->
            <v-row>
              <v-col class="my-n4">
                <v-text-field
                  v-model="periodic"
                  :rules="numberOnly"
                  label="Periodic Report (m)"
                  required
                ></v-text-field>
                <v-btn color="primary" class="float-right" @click="savePeriod(selectStation)">
                  SAVE
                </v-btn>
              </v-col>
            </v-row>

            </v-col>


            <v-divider
              class="d-none d-sm-flex"
              vertical
            ></v-divider>

            <v-col
              cols="12"
              sm="6"
            >

            <v-row>
              <v-col class="my-n4">
                <v-text-field
                  v-model="currentVersion"
                  label="Current Version Number"
                  readonly
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Wake Up -->
            <v-row>
              <v-col class="my-n4">
                <v-text-field
                  v-model="wakeUp"
                  :rules="numberOnly"
                  label="Wake Up (m)"
                  required
                ></v-text-field>
                <v-btn color="primary" class="float-right" @click="saveWakeUp(selectStation)">
                  SAVE
                </v-btn>
              </v-col>
            </v-row>

            <!-- Kalibrasi Batre -->
            <v-row>
              <v-col class="my-n4">
                <v-text-field
                  v-model="calibBat"
                  :rules="number"
                  label="Kalibrasi Baterai"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Offset Kalibrasi -->
            <v-row>
              <v-col class="my-n4">
                <v-text-field
                  v-model="offsetCal"
                  :rules="number"
                  label="Offset"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Tampilan satuan -->
            <v-row>
              <v-col class="my-n4">
                <p class="mb-n4">Satuan</p>
                <v-radio-group v-model="satuan" row mandatory>
                  <v-radio
                    label="centimeter"
                    value="cm"
                  ></v-radio>
                  <v-radio
                    label="meter"
                    value="m"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            

            </v-col>

          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="success darken-1"
                class="float-right"
                @click="save(selectStation)"
              >
                Save
              </v-btn>
              <v-btn color="error">
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-divider class="mx-2 my-4"></v-divider>

      <v-row>
        <v-col cols="4">
          <v-text-field
            v-model="CRC32"
            label="CRC32 TMA"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-btn
            color="blue darken-1"
            class="float-left mt-2"
            @click="saveCRC32"
            dark
          >
            Save
          </v-btn>
        </v-col>
      </v-row>
      

      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="data"
            :items-per-page="5"
            :calculate-widths="true"
            item-key="station"
            class="elevation-1"
            :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus'
            }"
          >
          <template v-slot:[`item.newVersion`]="{ item }">
            <span v-if="item.newVersion==undefined">
              N/A
            </span>
            <span v-else>
              {{item.newVersion}}
            </span>
          </template>
          <template v-slot:[`item.versi`]="{ item }">
            <span v-if="item.versi==undefined">
              N/A
            </span>
            <span v-else>
              {{item.versi}}
            </span>
          </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-divider class="mx-2 my-4"></v-divider>

      <h2>Request Log</h2>
      <v-row>
        <v-col>
          <v-select
            :items="stationsLog"
            label="Stasiun"
            v-model="selectStationLog"
            return-object
            :rules="nameRules"
            class="float-left"
            @change="getFileNames(selectStationLog);getFile(selectStationLog)"
          ></v-select>
          <v-btn class="ma-3 primary" @click="requestLog(selectStationLog)">Request</v-btn>
        </v-col>
        <v-col>
          <v-select
            :items="fileNames"
            label="Files"
            v-model="selectFile"
            return-object
            :rules="nameRules"
            class="float-left"
          ></v-select>
          <v-btn class="ma-3 primary" @click="requestFile(selectStationLog,selectFile)">Request</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span v-if="fileText">
            <v-btn class="float-end mb-2" color="primary" @click="download(fileNameServer,fileText)"><v-icon left>mdi-download</v-icon>Download</v-btn>
          </span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-container>
</template>

<script>
import { db }from "@/firebase/db.js"
// import firebase from "firebase/app"

import csvtojson from 'csvtojson'
import moment from 'moment'

export default {
  data: () => ({
    downloadErrFile:null,
    fileText:null,
    fileNameServer:null,
    selectFile:null,
    fileNames:[],
    selectStationLog:null,
    stationsLog:[],
    valid:false,
    stations:[],
    data:[],
    nameRules: [
      v => !!v || 'This Field is required'
    ],
    selectStation:null,
    number: [
      v => !!v || 'This Field is required',
      v => /^-?[0-9]*\.?[0-9]*$/.test(v) || 'Only number is allowed'
    ],
    numberOnly: [
      v => !!v || 'This Field is required',
      v => /^[0-9]*$/.test(v) || 'Only number is allowed'
    ],
    headers: [
      {
        text: 'Stasiun',
        align: 'start',
        value: 'station',
      },
      { text: 'Current Version', value: 'versi' },
      { text: 'Latest Version', value: 'newVersion'},
      { text: 'CRC32', value:'CRC32'},
      { text: 'Device ID', value:'id'},
      { text: 'Feeding ID', value:'feedingID'},
      { text: 'New ID', value:'newID'},
    ],
    CRC32:'',
    version:null,
    currentVersion:null,
    calibM:null,
    calibB:null,
    periodic:null,
    offset:null,
    offsetCal:null,
    wakeUp:null,
    calibBat:null,
    satuan:null,
    satuans: [
      'cm',
      'm'
    ]
  }),
  mounted () {
    const date=new Date();
    this.offset=date.getTimezoneOffset()/(-60)
    let loader = this.$loading.show()
    var radarRef = db.collection('radar')
    radarRef.orderBy("location","desc").onSnapshot((collectionSnapshot) => {
      this.stations=[]
      this.data=[]
      collectionSnapshot.forEach((doc) => {
          this.stations.push({text: doc.data().station, value: doc.id});
          this.data.push({id: doc.id, ...doc.data()});
          this.stationsLog.push({text: doc.data().station, value: doc.id});
      });
      this.stations.push({text:'All', value:'all'})
      this.deviceVersion=this.data
      this.CRC32=this.data[0].CRC32
      loader.hide()
      // this.loadingData=false
    })
  },
  methods: {
    updateTime (time) {
      return moment.unix(time).utcOffset(this.offset).format("DD/MMM/YY HH:mm")
    },
    change(station) {
      if (station.value!='all') {
        this.index = this.data.findIndex(x => x.id === station.value);
        this.version = this.data[this.index].newVersion
        this.currentVersion = this.data[this.index].versi
        this.calibM = this.data[this.index].calibM
        this.calibB = this.data[this.index].calibB
        this.periodic = this.data[this.index].periodic
        this.wakeUp = this.data[this.index].wakeUp
        this.calibBat = this.data[this.index].calibBat
        this.offsetCal = this.data[this.index].offset
        this.satuan = this.data[this.index].satuan
      }
    },
    save(station) {
      if (station.value!='all') {
        if (this.$refs.form.validate()) {
          let loader = this.$loading.show()
          var radarRef = db.collection('radar').doc(station.value)
          radarRef.update({
            newVersion: this.version,
            calibM: this.calibM,
            calibB:this.calibB,
            periodic:this.periodic,
            wakeUp:this.wakeUp,
            calibBat:this.calibBat,
            offset: this.offsetCal,
            satuan: this.satuan
          }).then(()=>{
            loader.hide()
          }).catch(()=> {
            loader.hide()
          })
        }
      }
    },
    savePeriodic(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('radar').doc(this.stations[i].value), {periodic:this.periodic})
        }
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    saveWakeUp(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('radar').doc(this.stations[i].value), {wakeUp:this.wakeUp})
        }
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    saveCRC32() {
      let loader = this.$loading.show()
      var batch =db.batch();
      for (let i=0; i<this.stations.length-1;i++) {
        batch.update(db.collection('radar').doc(this.stations[i].value), {CRC32:this.CRC32})
      }
      batch.commit().then(()=> {
        loader.hide()
      })
    },
    saveKuota() {
      let loader = this.$loading.show()
      var batch =db.batch();
      for (let i=0; i<this.stations.length-1;i++) {
        batch.update(db.collection('setting').doc(this.stations[i].value), {Kuota:this.kuota})
      }
      batch.commit().then(()=> {
        loader.hide()
      })
    },
    saveNomor() {
      let loader = this.$loading.show()
      var batch =db.batch();
      for (let i=0; i<this.stations.length-1;i++) {
        batch.update(db.collection('setting').doc(this.stations[i].value), {Nomor:this.nomor})
      }
      batch.commit().then(()=> {
        loader.hide()
      })
    },
    saveVersion(station) {
      let loader = this.$loading.show()
      if (station.value=='all') {
        var batch =db.batch();
        for (let i=0; i<this.stations.length-1;i++) {
          batch.update(db.collection('radar').doc(this.stations[i].value), {newVersion:this.version})
        }
        batch.commit().then(()=> {
          loader.hide()
        })
      } else {
        loader.hide()
      }
    },
    async requestLog(station) {
      console.log(station.value)
      let loader = this.$loading.show()
      await db.collection('radar').doc(station.value).update({
        requestFile:'1'
      }).then(()=> {
        loader.hide()
      })
    },
    async getFileNames(station) {
      this.fileNames=[]
      await db.collection('filesErrRadar').doc(station.value).get().then((res)=> {
        csvtojson()
        .fromString(res.data().fileNames)
        .then((csvRow)=>{ 
          csvRow.forEach((data)=> {
            this.fileNames.push({
              value:data.name,
              text: `${this.updateTime(parseInt(data.name))} - ${Number(data.size/1024).toFixed(2)}KB`
            })
          })
        })
      }).catch((err)=> {
        console.log(err)
      })
    },
    async requestFile(station,time) {
      let loader = this.$loading.show()
      await db.collection('radar').doc(station.value).update({
        requestFileTime:time.value
      }).then(()=> {
        loader.hide()
      })
    },
    async getFile(station) {
      await db.collection('filesErrRadar').doc(station.value).get().then((res)=> {
        this.fileText=res.data().data
        this.fileNameServer = res.data().title
        csvtojson()
        .fromString(res.data().fileNames)
        .then((csvRow)=>{ 
          this.downloadErrFile=csvRow
        })
      }).catch((err)=> {
        console.log(err)
      })
    },
    download(filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
  }
}
</script>